import type { Category } from '@/types/entity/category';
import type { CategoryNode, ProductCategory } from '../../types';

// Map the project's commercetools-derived `Category` tree (already
// returned by `useCategories` / passed to tastics as `treeCategories`)
// into the recursive `CategoryNode` shape the slide-out renders.
//
// Depth: arbitrary. The slide-menu walks `children` recursively at
// render time and indents per depth. Empty / nameless CT categories
// are filtered out at every level so a half-configured tree doesn't
// render blank rows.
const toCategoryNode = (category: Category): CategoryNode => {
  const namedDescendants = (category.descendants ?? []).filter((c) => c.name);
  const children = namedDescendants.map(toCategoryNode);
  return {
    label: category.name,
    href: category.path || `/${category.categoryKey ?? category.categoryId}`,
    ...(children.length > 0 ? { children } : {}),
  };
};

const mapCategories = (categories: Category[]): ProductCategory[] =>
  categories.filter((c) => c.name).map(toCategoryNode);

export default mapCategories;
